<template>
    <div class="permission-wrap">
        <div class="without_permission">
            <div class="withoutPermission-page">
                <!-- <div class="withoutPermission-page-close">
                    <i class="asm-icon-close"></i>
                </div> -->
                <div class="withoutPermission-page-logo"></div>
                <div class="withoutPermission-page-tips">
                    <p>您无权限查看或操作该页面。</p>
                    <p>如有需求，请联系您的客户经理或者咨询Ext_apple@baidu.com</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WithoutPermission'
};
</script>
<style lang="scss">
.permission-wrap {
    position: absolute;
    top: 15px;
    left: 20px;
    bottom: 20px;
    right: 20px;
}
.without_permission {
    width: 100%;
    height: 100%;
    background: #fff;
    // min-height: 650px;
    box-shadow: -3px 2px 2px 0 rgba(119,151,178,0.16);
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    .withoutPermission-page {
        position: relative;
        .withoutPermission-page-close {
            position: absolute;
            top: -20px;
            right: 20px;
            cursor: pointer;
        }
        .withoutPermission-page-logo {
            width: 53px;
            height: 50px;
            margin: 10px auto 15px;
            background: url('./assets/images/withoutPermission.png') center center no-repeat;
            background-size: contain;
        }
        .withoutPermission-page-tips {
            text-align: center;
            color: #53575B;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            margin-bottom: 10px;
            line-height: 1.8;
            p {
                margin: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/modules/cmp/permission.vue